<template>
    <div>
        <div class="module-container">
            <div class="card-status-center">
                <card-status :consSocket="conSocket"/>
            </div>

            <div class="col-md-8">
                <select class="form-control" name="queues" id="queueSelect" v-model="queueSelect">
                    <option value="*">Todas as filas</option>
                    <option v-for="q in queues" :key="q.id" :value="q.name">{{ q.name }}</option>
                </select>
                
                <div class="cards-container">
                    <card-realtime
                     v-for="op in filteredOperators"
                     :id="op.id"
                     :key="op.id"
                     :nome="op.nome" 
                     :extension="op.extension_line"
                     :status="userStatus"
                     :connection="conSocket"
                     :userQueues="op.queues"
                    ></card-realtime>
                </div>
            </div>

            <div class="col-md-4">
                <calls-queue :connection="conSocket"/>
                <total-calls :connection="conSocket"/>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import cardRealtime from './CardRealtime.vue';
import cardStatus from './CardStatus.vue';
import callsQueue from './CallsinQueue';
import totalCalls from './TotalCalls';

export default {
    props: ["conSocket"],
    components: {
        cardRealtime,
        cardStatus,
        callsQueue,
        totalCalls
    },
    data() {
        return {
            operators: [],
            connection: {},
            queueStatus: [],
            queues: [],
            queueSelect: '*'
        }
    },
    methods: {
        groupQueues() {
            this.queueStatus = [];
        },
        allQueues() {
            return axios.get('/listQueue').then(({ data }) => {
                if (data && data.length > 0) {
                    this.queues = data.sort((a, b) => {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    });
                }
            });
        },
        setupSocketConnection() {
            const parsedTelefone = (process.env.MIX_TELEFONE === 'true');

            if (this.conSocket && this.conSocket.connected) {
                this.conSocket.removeAllListeners();
                this.conSocket.disconnect();
            }

            if (parsedTelefone) {
              this.conSocket.on('connect', () => {
                console.info('Conectado ao serviço do realtime');
                this.conSocket.emit('QueueStatus');
              });
          
              this.conSocket.on('disconnect', (reason) => {
                console.info(`Desconectado: ${reason}`);
              });
          
              this.conSocket.on('reconnect_attempt', (attemptNumber) => {
                console.info(`Tentativa de reconexão #${attemptNumber}`);
              });
            } else {
              this.conSocket = {
                on: function() {},
                emit: function() {}
              };
            }
        }
    },
    created() {
        this.allQueues();
        this.setupSocketConnection();
        axios.get('/realtime/listUsersPhone').then(({ data }) => {
            this.operators = data;
        });
        
        this.userStatus = 'Deslogado';
    },
    mounted() {
        this.conSocket.emit('QueueStatus');
        setInterval(() => {
            setTimeout(async () => {
                this.conSocket = {
                    on: function() {},
                    emit: function() {}
                };
                this.setupSocketConnection();
                this.conSocket.emit('QueueStatus');
            }, 1000)
        }, 300000); //5 MINUTOS
    },
    computed: {
        filteredOperators() {
            if (this.queueSelect != '*') {
                return this.operators.filter(el => {
                    return el.queues.some(queue => {
                        return queue.name.includes(this.queueSelect);
                    });
                });
            } else {
                return this.operators;
            }
        }
    }
}
</script>

<style scoped>
.module-container {
    display: flex;
    flex-wrap: wrap;
}
.cards-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.card-status-center{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
#queueSelect {
    width: 200px !important
}
</style>